module.exports = __webpack_public_path__ + "static/media/add.e7d4fe55.svg";